"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var yup_1 = require("yup");
exports.initializeYupLocales = function (i18n) {
    return yup_1.setLocale({
        mixed: {
            default: i18n.t('yup:mixed:default'),
            required: i18n.t('yup:mixed:required'),
            oneOf: i18n.t('yup:mixed:oneof'),
            notOneOf: i18n.t('yup:mixed:notoneof'),
            notType: i18n.t('yup:mixed:nottype')
        },
        string: {
            length: function (_a) {
                var length = _a.length;
                return i18n.t('yup:string:length', { length: length });
            },
            min: function (_a) {
                var min = _a.min;
                return i18n.t('yup:string:min', { min: min });
            },
            max: function (_a) {
                var max = _a.max;
                return i18n.t('yup:string:max', { max: max });
            },
            matches: function (_a) {
                var regex = _a.regex;
                return i18n.t('yup:string:matches', { regex: regex });
            },
            email: function (_a) {
                var regex = _a.regex;
                return i18n.t('yup:string:email', { regex: regex });
            },
            url: function (_a) {
                var regex = _a.regex;
                return i18n.t('yup:string:url', { regex: regex });
            },
            trim: i18n.t('yup:string:trim'),
            lowercase: i18n.t('yup:string:lowercase'),
            uppercase: i18n.t('yup:string:uppercase')
        },
        number: {
            min: function (_a) {
                var min = _a.min;
                return i18n.t('yup:number:min', { min: min });
            },
            max: function (_a) {
                var max = _a.max;
                return i18n.t('yup:number:max', { max: max });
            },
            lessThan: function (_a) {
                var less = _a.less;
                return i18n.t('yup:number:lessthan', { less: less });
            },
            moreThan: function (_a) {
                var more = _a.more;
                return i18n.t('yup:number:morethan', { more: more });
            },
            positive: function (_a) {
                var more = _a.more;
                return i18n.t('yup:number:positive', { more: more });
            },
            negative: function (_a) {
                var less = _a.less;
                return i18n.t('yup:number:negative', { less: less });
            },
            integer: i18n.t('yup:number:integer')
        },
        date: {
            min: function (_a) {
                var min = _a.min;
                return i18n.t('yup:date:min', { min: min });
            },
            max: function (_a) {
                var max = _a.max;
                return i18n.t('yup:date:max', { max: max });
            }
        },
        object: {
            noUnknown: i18n.t('yup:object:nounknown')
        },
        array: {
            min: function (_a) {
                var min = _a.min;
                return i18n.t('yup:array:min', { min: min });
            },
            max: function (_a) {
                var max = _a.max;
                return i18n.t('yup:array:max', { max: max });
            }
        }
    });
};
//# sourceMappingURL=yup-locales.js.map